import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders } from '../headers';

import {
  PACKING_RULES_INDEX_REQUESTED,
  PACKING_RULES_INDEX_SUCCESS,
  PACKING_RULES_INDEX_FAILURE,
  PACKING_RULE_CREATE_REQUESTED,
  PACKING_RULE_CREATE_SUCCESS,
  PACKING_RULE_CREATE_FAILURE,
  PACKING_RULE_UPDATE_REQUESTED,
  PACKING_RULE_UPDATE_SUCCESS,
  PACKING_RULE_UPDATE_FAILURE,
  PACKING_RULE_DELETE_REQUESTED,
  PACKING_RULE_DELETE_SUCCESS,
  PACKING_RULE_DELETE_FAILURE,
  PACKING_RULE_FILE_UPLOAD_REQUESTED,
  PACKING_RULE_FILE_UPLOAD_SUCCESS,
  PACKING_RULE_FILE_UPLOAD_FAILURE,
} from '../types';

export const packingRulesIndexRequested = () => {
  return {
    type: PACKING_RULES_INDEX_REQUESTED
  }
};

export const packingRulesIndexSuccess = (packingRules) => {
  return {
    type: PACKING_RULES_INDEX_SUCCESS,
    payload: packingRules
  }
};

export const packingRulesIndexFailure = () => {
  return {
    type: PACKING_RULES_INDEX_FAILURE
  }
};

export const packingRuleCreateRequested = () => {
  return {
    type: PACKING_RULE_CREATE_REQUESTED
  }
};

export const packingRuleCreateSuccess = (packingRule) => {
  return {
    type: PACKING_RULE_CREATE_SUCCESS,
    payload: packingRule
  }
};

export const packingRuleCreateFailure = () => {
  return {
    type: PACKING_RULE_CREATE_FAILURE
  }
};

export const packingRuleUpdateRequested = () => {
  return {
    type: PACKING_RULE_UPDATE_REQUESTED
  }
};

export const packingRuleUpdateSuccess = (packingRule) => {
  return {
    type: PACKING_RULE_UPDATE_SUCCESS,
    payload: packingRule
  }
};

export const packingRuleUpdateFailure = () => {
  return {
    type: PACKING_RULE_UPDATE_FAILURE
  }
};

export const packingRuleDeleteRequested = (packingRuleId) => {
  return {
    type: PACKING_RULE_DELETE_REQUESTED,
    packingRuleId: packingRuleId
  }
};

export const packingRuleDeleteSuccess = () => {
  return {
    type: PACKING_RULE_DELETE_SUCCESS
  }
};

export const packingRuleDeleteFailure = () => {
  return {
    type: PACKING_RULE_DELETE_FAILURE
  }
};

export const packingRuleFileUploadRequested = () => {
  return {
    type: PACKING_RULE_FILE_UPLOAD_REQUESTED
  }
};

export const packingRuleFileUploadSuccess = () => {
  return {
    type: PACKING_RULE_FILE_UPLOAD_SUCCESS
  }
};

export const packingRuleFileUploadFailure = () => {
  return {
    type: PACKING_RULE_FILE_UPLOAD_FAILURE
  }
};

export const packingRulesIndex = () => {
  return async (dispatch) => {
    dispatch(packingRulesIndexRequested());

    const endPoint = Config.baseUrl + Config.packingRules;

    return Axios.get(endPoint, { headers: await authHeaders() })
      .then((response) => {
        dispatch(packingRulesIndexSuccess(response.data));
      })
      .catch(() => {
        dispatch(packingRulesIndexFailure());
      });
  }
}

export const packingRuleCreate = (rule) => {
  return async (dispatch) => {
    dispatch(packingRuleCreateRequested());

    const endPoint = Config.baseUrl + Config.packingRule;

    return Axios.post(endPoint, rule, { headers: await authHeaders() })
      .then((response) => {
        dispatch(packingRuleCreateSuccess(response.data));
      })
      .catch(() => {
        dispatch(packingRuleCreateFailure());
      });
  }
}

export const packingRuleUpdate = (rule) => {
  return async (dispatch) => {
    dispatch(packingRuleUpdateRequested());

    const endPoint = Config.baseUrl + Config.packingRule;

    return Axios.put(endPoint, rule, { headers: await authHeaders() })
      .then((response) => {
        dispatch(packingRuleUpdateSuccess(response.data));
      })
      .catch(() => {
        dispatch(packingRuleUpdateFailure());
      });
  }
}

export const packingRuleDelete = (id) => {
  return async (dispatch) => {
    dispatch(packingRuleDeleteRequested(id));

    const endPoint = Config.baseUrl + Config.packingRule + id;

    return Axios.delete(endPoint, { headers: await authHeaders() })
      .then((response) => {
        dispatch(packingRuleDeleteSuccess(response.data));
      })
      .catch(() => {
        dispatch(packingRuleDeleteFailure());
      });
  }
}

// Print-item insert upload: fetch a presigned PUT URL for the rule, then PUT
// the PDF straight to S3 - the same mechanism as the store logo upload.
export const packingRuleFileUpload = (ruleId, file) => {
  return async (dispatch) => {
    dispatch(packingRuleFileUploadRequested());

    const cleanedFileName = file.name.replace(/ /g, '_');
    const endPoint = Config.baseUrl + Config.packingRule + ruleId + '/file_upload/' + cleanedFileName;

    return Axios.get(endPoint, { headers: await authHeaders() })
      .then((response) => {
        return Axios.put(response.data.upload_link, file, {
          headers: { 'Content-Type': 'application/pdf' }
        });
      })
      .then(() => {
        dispatch(packingRuleFileUploadSuccess());
        dispatch(packingRulesIndex());
      })
      .catch(() => {
        dispatch(packingRuleFileUploadFailure());
      });
  }
}
